import { render } from "./IntroParagraphSelector.vue?vue&type=template&id=59cba8c6&scoped=true"
import script from "./IntroParagraphSelector.vue?vue&type=script&lang=js"
export * from "./IntroParagraphSelector.vue?vue&type=script&lang=js"

import "./IntroParagraphSelector.vue?vue&type=style&index=0&id=59cba8c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59cba8c6"]])

export default __exports__